import { render, staticRenderFns } from "./SwitchesBoolean.vue?vue&type=template&id=6a8d8b68&"
import script from "./SwitchesBoolean.vue?vue&type=script&lang=js&"
export * from "./SwitchesBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports